import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["href"];
import { spriteHref } from "./sprites";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Sprite',
    props: {
        name: { type: String, required: true },
        size: { type: [Number, String], default: 16 },
        width: Number,
        height: Number,
        clear: Boolean,
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(__props.clear ? 'svg-clr' : 'svg'),
                width: __props.width ?? __props.size,
                height: __props.height ?? __props.width ?? __props.size
            }, [
                _createElementVNode("use", {
                    href: _unref(spriteHref)(`${__props.name}-${__props.width ?? __props.size}`, __props.clear)
                }, null, 8 /* PROPS */, _hoisted_2)
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
